module.exports = __webpack_public_path__ + "img/ss_green-02.2969cd35.jpg";